$(document).on('load turbolinks:load', function() {
	jQuery('#rootwizard').bootstrapWizard({
        onTabShow: function(tab, navigation, index) {
            var $total = navigation.find('li').length;
            var $current = index + 1;
            var $percent = ($current / $total) * 100;
            $('#rootwizard .progressbar').css({
                width: $percent + '%'
            });
        }
    });
    jQuery('#rootwizard .finish').click(function() {
        jQuery('#success-modal').modal();
    });

    /******** Tabpane helper for login page ********/
    jQuery('.loginToggler').click(function(e) {
        jQuery('.loginToggler').removeClass('active');
    });

    // ------------------------------------------------------- //
    // Custom Checkbox
    // ------------------------------------------------------ //
    jQuery('.checkbox').click(function() {
        jQuery(this).toggleClass('is-checked');
    });


    // ------------------------------------------------------- //
    // Check / Uncheck all checkboxes
    // ------------------------------------------------------ //
    jQuery("#check-all").change(function() {
        jQuery("input:checkbox").prop('checked', jQuery(this).prop("checked"));
    });


});
